export class EnumField<R = any> {
  constructor(readonly values: ReadonlyArray<R>) {}
}
